/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { get, map, toString, pickBy, identity, isEmpty, find } from "lodash";
import { IconButton, Pagination, Stack, Chip, Menu, MenuItem, Link as LinkMui, CircularProgress, Box, Fade, Typography, Dialog } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Question from '../../../components/form/Question';
import { Link } from "react-router-dom";
import moment from "moment";
import LanguageIcon from '@mui/icons-material/Language'; 

import Layout from "../../../components/layout/Layout"
import Table from "../../../components/form/TableFilter";
import Toolbar from "./Toolbar";
import Notification from "../../../components/form/Notification";
import Alert from "../../../components/form/Alert";
import { PageSize, countPage } from "../../../config/const"

import { getRoute } from "../../../store/transactions/thunk/route/getAll";
import { getClientsRoute } from "../../../store/transactions/thunk/clientsRoutes/getAll";
import { deleteRoute } from "../../../store/transactions/thunk/route/delete";
import { postNewRoute } from "../../../store/transactions/thunk/importRoute/post";
import { useCanView } from "../../../config/hook/UserPermissions";

const Route = () => {
  const [__] = useTranslation("route");
  const dispatch = useDispatch();
  const [filter, setFilter] = useState({});
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const [selected, setSelected] = useState({});
  const canView = useCanView();
  const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })
  const [openQuestion, setOpenQuestion] = useState(null);
  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" })
  const [isUploading, setIsUploading] = useState(false);

  const route = useSelector(state => state.transactions.route);
  const put = useSelector(state => state.transactions.route.put);
  const delet = useSelector(state => state.transactions.route.delete);
  const clientsRoute = useSelector(state => state.transactions.clientsRoute);
  const post = useSelector(state => state.transactions.newRoute.post);


  const routeStatus = __(`routeStatus`, { returnObjects: true });

  const getDataClients = () => {
    dispatch(getClientsRoute({ Export: true }));
  }

  const getData = ({page, filters = filter}) => {
    dispatch(getRoute({page, ...filters}))
  }

  const reload = () => getData({ page: 1})

  useEffect(() => {
    setAnchorEl(false)
    getData({ page: 1})
    getDataClients();
  }, [])

  const handleOpenMenu = (row) => (event) => {
    setSelected(row)
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setSelected({})
    setAnchorEl(null);
  };

  const onFilterChange = (key, value) => {
    const updatedFilters = { ...filter, [key]: value };
    setFilter(updatedFilters);
    getData({ page: 1, filters: updatedFilters });
  };


  //  --------- Delete -------------

  const closeAlert = () => {
    setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
  }

  const setError = (err, action) => {
    if (!isEmpty(err) && !!get(err, "Message", "")) {
      setAlert({
        open: true,
        title: get(err, "Message", ""),
        subtitle: (<ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>),
        type: "error",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    } else {
      setAlert({
        open: true,
        type: "error",
        title: "Uno o más errores de validación han ocurrido.",
        subtitle: (<li>{` ${get(err, "ErrorMessage")}`}</li>),
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    }
    handleCloseMenu()
  }

  const handleDelete = (row) => () => {
    setAnchorEl(null)
    setOpenQuestion(true)
    setSelected(row)
  }

  const onDelete = () => {
    dispatch(deleteRoute(Number(get(selected, "idRoute"))))
    setSelected({})
    setOpenQuestion(false)
  }

  const handleFileUpload = (file) => {
    dispatch(postNewRoute(file)); 
  };

  useEffect(() => {
    if (get(post, "isSuccess", false)) {
      setIsUploading(false);  // Permite nuevas cargas
    }
    if (get(post, "isReject", false)) {
      setIsUploading(false);  // Resetea en caso de error
    }
  }, [post]);

  useEffect(() => {
    if (get(delet, "isSuccess", false)) { reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "delet" }) }
    if (get(delet, "isReject", false)) { setError(get(delet, "error", {}), "delet") }
    if (get(put, "isSuccess", false)) { reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "put" }) }
    if (get(put, "isReject", false)) { setError(get(put, "error", {}), "put") }
    if (get(post, "isSuccess", false)) { reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "post" }); }
    if (get(post, "isReject", false)) { setError(get(post, "error", {}), "post") }
  }, [put, delet, post])

  const headTable = [
    {
      key: "routeStatus",
      label: __(`table.cols.statusOperative`),
      align: "center",
    },
    {
      key: "code",
      label: __(`table.cols.idRoute`),
      align: "center"
    },
    {
      key: "routeName",
      label: __(`table.cols.routeName`),
      align: "center"
    },
    {
      key: "customerId",
      label: __(`table.cols.customerId`),
      align: "center"
    },
    {
      key: "dateRoute",
      label: __(`table.cols.dateToRoute`),
      align: "center",
      sx: { minWidth: 150 }
    },
    {
      key: "createDate",
      label: __(`table.cols.creationDate`),
      align: "center",
      sx: { minWidth: 150 }
    },
    {
      key: "transportName",
      label: __(`table.cols.transportName`),
      align: "center"
    },
    {
      key: "startDpDescription",
      label: __(`table.cols.startPoint`),
      align: "center"
    },
    {
      key: "endDpDescription",
      label: __(`table.cols.endPoint`),
      align: "center"
    },
    {
      key: "trackingUrl",
      label: __(`table.cols.trackingUrl`),
      align: "center"
    },
    {
      key: "options",
      label: __(`table.cols.options`),
      align: "center",
      sx: { position: "sticky", right: 0, pr: 1, background: "linear-gradient(90deg, hsla(0, 0%, 100%, 1) 0%, hsla(0, 0%, 87%, 1) 8px, hsla(0, 0%, 100%, 1) 8px, hsla(0, 0%, 100%, 1) 100%)" }
    },
  ]
  const dataTable = map(get(route, "data.data", []), (row, i) => ({
    ...row,
    dateRoute: new Date(get(row, "dateToRoute")).toISOString().split('T')[0],
    createDate: (
      <>
        {moment(get(row, "creationDate")).isSame(new Date(), 'day') ? (
          <>
            <Chip label="Nueva" size="small" sx={{  color: 'white', backgroundColor: '#0096ce', position: 'relative', fontSize: '0.65rem', marginRight: '5px'}} />
            {new Date(get(row, "creationDate")).toISOString().split('T')[0]}
          </>
        ) : (
          new Date(get(row, "creationDate")).toISOString().split('T')[0]
        )}
      </>
    ),
    routeStatus: <Chip label={get(find(routeStatus, ({ value }) => value === get(row, "idRouteStatus", 1)), "label")} sx={{ bgcolor: `${get(find(routeStatus, ({ value }) => value === get(row, "idRouteStatus", 1)), "color")}26`, color: get(find(routeStatus, ({ value }) => value === get(row, "idRouteStatus", 1)), "color") }} />,
    code: <LinkMui component={Link} to={toString(get(row, "idRoute"))} >{get(row, "idRoute")}</LinkMui>,
    trackingUrl: get(row, "trackingUrl") ? (<IconButton aria-label="open tracking" size="small" onClick={() => window.open(`${window.location.origin}/${get(row, "trackingUrl")}`, "_blank")} sx={{ color: "blue" }} > <LanguageIcon /> </IconButton>) : null,
    options: <IconButton aria-label="more" size="small" onClick={handleOpenMenu(row)}><MoreVertIcon fontSize="inherit" /></IconButton>
  }))

  const onChangePagination = (e, page) => getData({ page })

  return (
    <Layout
      propsToolbar={{
        title: __(`head.name`),
        code: null,
        btnLabel: null
      }}
    >
      <Toolbar setFilter={setFilter} __={__} getData={getData} reload={reload} isLoading={get(route, "isLoading", false)} callBackRoute={handleFileUpload} />
      <Table headTable={headTable}
        dataTable={dataTable}
        __={__}
        sizeFilters={125}
        propsTable={{ showFilterRow: true }}
        filters={filter}
        onFilterChange={onFilterChange}
        loading={get(route, "isLoading", false)}
      />
      <Stack sx={{ mt: 2 }} alignItems="flex-end">
        <Pagination
          count={countPage(get(route, "data.totalRecord", 1))}
          page={get(route, "data.currentPage", 1)}
          onChange={onChangePagination}
          color="secondary"
          sx={{ "& li > button": { borderRadius: 1 } }}
          disabled={get(route, "isLoading", false)}
        />
      </Stack>
      {(get(post, "isLoading", false) ) && (
         <Dialog open={get(post, "isLoading")} maxWidth="sm" sx={{ '& .MuiDialog-paper': {width: '250px', maxWidth: '90%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 3 }}} >
          <Fade in={get(post, "isLoading")}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 3 }}>
              <CircularProgress />
              <Typography variant="caption" sx={{ mt: 2, ml: 2 }}>
                {__("Cargando...")}
              </Typography>
            </Box>
          </Fade>
        </Dialog>
      )}
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleCloseMenu}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'center' }}
        anchorOrigin={{ horizontal: 'left', vertical: 'center' }}
      >
        <Link to={toString(get(selected, "idRoute"))}><MenuItem >{__(`table.menu.edit`)}</MenuItem></Link>
        <MenuItem 
          onClick={() => {
            if (canView("TRANSACCIONES/RUTAS", "delete")) {
              if ([1, 2].includes(get(selected, "idRouteStatus"))) {
                handleDelete(selected)();
              } else {
                setAlert({
                  open: true,
                  title: "Error de Validación",
                  subtitle: (<ul> • El estado de la ruta no permite la eliminación.</ul>),
                  type: "error",
                  btn: __(`${module}.actions.close`),
                  func: closeAlert
                })
              }
            } else {
              setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: (<ul> • No tienes permiso para eliminar rutas.</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
              })
            }
          }}>{__(`table.menu.delete`)}
        </MenuItem>
      </Menu>
      <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
      <Alert
        title={get(alert, "title")}
        subtitle={get(alert, "subtitle")}
        btn1={{ func: get(alert, "func") }}
        btn2={{}}
        type={get(alert, "type")}
        openAlert={get(alert, "open")}
        closeAlert={closeAlert}
      />
      <Question
        title={__("alert.deleteRoute")}
        detail={__("alert.deleteRouteDetail")}
        onSuccess={onDelete}
        onCancel={() => setOpenQuestion(false)}
        open={openQuestion}
        loading={get(delet, "isLoading")}
      />
    </Layout>
  )
}

export default Route;


